import React, { lazy, Suspense } from 'react'
import { useLocation, useParams, useRoutes } from 'react-router-dom'
import { OptionalRoute, routes } from './index'

import AdminLayout from '@/pages/AdminLayout'
import { selectPermissions } from '@/reducers/authentication'
import { getToken } from '@/utils/indexDB'
import { checkPermission } from '@/utils/Utils'
import { Loading } from '@greenglobal/greencore.fe.common'
import { useSelector } from 'react-redux'
import './styles.scss'

interface PartialRouteObject {
  caseSensitive?: boolean
  children?: PartialRouteObject[]
  element: React.ReactNode
  path: string
}
interface AsyncComponentProps {
  name: string
  privateRouter: boolean
  isMenu?: boolean
  permissions: string[]
  path: string
}

const AsyncComponent: React.FC<AsyncComponentProps> = ({ name, isMenu, ...props }) => {
  const accessToken = getToken()
  const location = useLocation()
  const params = useParams()
  const permissions = useSelector(selectPermissions)

  if (accessToken && props.privateRouter && !checkPermission(props?.permissions, permissions)) {
    window.location.replace('/403')
  }

  const Component = lazy(() => import(`../pages/${name}.tsx`))

  const renderComponent = (
    <Suspense
      fallback={
        <Loading
          className='loading'
          loading
          paragraph={{
            rows: 6,
            width: 100
          }}
          size='default'
          style={{
            width: 450
          }}
          type='INDICATOR'
        />
      }
    >
      <Component {...props} match={{ params }} location={location} />
    </Suspense>
  )

  if (!isMenu) {
    return renderComponent
  }
  return <AdminLayout>{renderComponent}</AdminLayout>
}

const generateRoutes = (routes: OptionalRoute[]): PartialRouteObject[] => {
  return routes.map(({ path, componentName, privateRouter = false, isMenu = false, permissions }) => {
    return {
      element: (
        <AsyncComponent
          permissions={permissions}
          name={componentName}
          privateRouter={privateRouter}
          isMenu={isMenu}
          path={path}
        />
      ),
      path
    }
  })
}

export default function RenderRouter() {
  return useRoutes([...generateRoutes(routes)])
}
